/** @format */

import auth from "./reducer";

const reducer = auth;

export * from "./reducer";
export default reducer;
